module.exports = __webpack_public_path__ + "img/CAB094_F9ECDD_EFDEC8_E8D4BD-256px.01c5c5d4.png";